import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Typography } from '@robinpowered/ui-kit';
export var InternalModal = function (_a) {
    var onConfirm = _a.onConfirm, onCancel = _a.onCancel, title = _a.title, byline = _a.byline, confirmText = _a.confirmText, cancelText = _a.cancelText, confirming = _a.confirming;
    return (_jsx(Modal, { title: title, cancelText: cancelText, okType: 'danger', okText: confirmText, onCancel: function () {
            onCancel();
        }, confirmLoading: confirming, onOk: function () {
            onConfirm();
        }, open: true, children: _jsx(Typography.Text, { type: "secondary", children: byline }) }));
};
